import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import { Printer } from "@phosphor-icons/react";
import { fmt } from "@/lib/format";
import { printNode, buildReceiptHTML } from "@/lib/print";

export default function ReceiptDialog({ order, settings, onClose }) {
  if (!order) return null;
  const date = new Date(order.created_at);

  const handlePrint = () => {
    printNode(buildReceiptHTML(order, settings), `Receipt #${order.order_number}`);
  };

  return (
    <Dialog open={!!order} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm p-0 overflow-hidden" data-testid="receipt-dialog">
        <div className="p-6 max-h-[80vh] overflow-y-auto font-mono text-sm print-target" id="receipt-print">
          <div className="text-center">
            <div className="font-display text-2xl font-black tracking-tight">{settings.outlet_name}</div>
            <div className="text-[11px] text-stone-500 uppercase tracking-widest mt-1">Boba Tea</div>
          </div>
          <div className="border-t border-dashed border-stone-300 my-4"></div>
          <div className="flex justify-between text-xs">
            <span>Order #{order.order_number}</span>
            <span>{date.toLocaleString()}</span>
          </div>
          <div className="text-xs text-stone-500 mt-1">Served by {order.staff_name}</div>
          <div className="border-t border-dashed border-stone-300 my-4"></div>

          {order.items.map((it, i) => (
            <div key={i} className="mb-3">
              <div className="flex justify-between">
                <span className="font-semibold">{it.quantity}× {it.name}</span>
                <span>{fmt(it.line_total)}</span>
              </div>
              <div className="text-[11px] text-stone-500 pl-3">
                {it.size} · Sugar {it.sugar} · Ice {it.ice}
              </div>
              {it.toppings.length > 0 && (
                <div className="text-[11px] text-stone-500 pl-3">
                  + {it.toppings.map((t) => t.name).join(", ")}
                </div>
              )}
              {it.notes && (
                <div className="text-[11px] text-stone-500 pl-3 italic">Note: {it.notes}</div>
              )}
            </div>
          ))}

          <div className="border-t border-dashed border-stone-300 my-4"></div>
          <div className="space-y-1">
            <div className="flex justify-between"><span>Subtotal</span><span>{fmt(order.subtotal)}</span></div>
            {order.discount > 0 && <div className="flex justify-between"><span>Discount</span><span>-{fmt(order.discount)}</span></div>}
            {order.packaging_total > 0 && <div className="flex justify-between"><span>Packaging</span><span>{fmt(order.packaging_total)}</span></div>}
            <div className="flex justify-between"><span>Tax</span><span>{fmt(order.tax)}</span></div>
            <div className="flex justify-between text-lg font-bold pt-2 border-t border-dashed border-stone-300 mt-2">
              <span>Total</span><span>{fmt(order.total)}</span>
            </div>
            <div className="flex justify-between pt-2 text-stone-600">
              <span>Paid · {order.payment_method.toUpperCase()}</span>
              <span>{fmt(order.payment_method === "cash" ? order.cash_received : order.total)}</span>
            </div>
            {order.change !== null && order.change !== undefined && (
              <div className="flex justify-between"><span>Change</span><span>{fmt(order.change)}</span></div>
            )}
          </div>
          <div className="border-t border-dashed border-stone-300 my-4"></div>
          <div className="text-center text-xs text-stone-500">
            Thank you! See you again 🧋
          </div>
        </div>
        <div className="p-3 border-t border-boba-stoneLine bg-boba-cream flex gap-2 no-print">
          <button
            onClick={handlePrint}
            className="flex-1 h-11 bg-white border border-boba-stoneLine rounded-md font-medium text-sm hover:bg-stone-50 flex items-center justify-center gap-2"
            data-testid="receipt-print"
          >
            <Printer size={18} /> Print
          </button>
          <button
            onClick={onClose}
            className="flex-1 h-11 bg-boba-matcha hover:bg-boba-matchaDark text-white rounded-md font-medium text-sm"
            data-testid="receipt-done"
          >
            New Order
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
